import * as React from 'react';
import RenderDimensionsFields from "../../RenderDimensionsFields";
import Icons from '../../Icons';
import {useEffect, useState} from "react";
import {SelectOutlineProcessing} from "./SelectOutlineProcessing";
import {RollbackAction} from "./RollbackAction";
import {cmjnData, UpdateCmjn} from "./UpdateCmjn";
import {getShopRefInStorage} from "../../MonCompteAction";
import BtnEditorPicker from './BtnEditorPicker';

interface EditorMenuProps {
  data: any;
  changeOptionEvent: any;
  resetCustomOptions: any;
  handleChangeColors: any;
  submitHandleChangeColors: any;
  getPreview: any;
  updateDimensions: any;
  onDownloadFile: any;
  showResize: boolean;
  onChangeOutlineProcessing: any;
  onlyDownload: boolean;
  onApplyOutline: (applyOutline: boolean, colorOutline: string) => void;
  onRollback: () => void;
  onUpdateCmjn?: (idCaddies: string, cmjnData: cmjnData) => void;
  canUpdateCmjn: boolean;
  canUpdateOutlineProcessing: boolean;
  canDownloadEmbroidery: boolean;
}


export const EditorMenu = (props: EditorMenuProps) => {
  const [batAutoRotation, setBatAutoRotation] = useState(props.data.batAutoRotation);
  const [batAutoRemoveBackground, setBatAutoRemoveBackground] = useState(props.data.batAutoRemoveBackground);
  const [showResize, setShowResize] = useState(props.showResize);
  const [isDeplieCmjn, enableDeplieCmjn] = useState(false);
  const reuploadAdminBatValide = (props.data.isInternalUserAdmin && !props.data.customerView) &&
    props.data.order.validation_bat == '2' && props.data.order.confirmationFichier == '1' &&
    (props.data.order.StatutCommande == '5' || props.data.order.StatutCommande == '6' || props.data.order.StatutCommande == '7');
  const reuploadBtnAdminBatValide = reuploadAdminBatValide && props.data.originalFileInfos?.statutLigneMarquageId === 2;
  const canCustomDimensions =  (props.data.validationBat == '0' && ((props.data.order.confirmationFichier == '0' && props.data.canCustomDimensionsBatAuto) || (props.data.isInternalUser && !props.data.customerView) ||  (props.data.order.confirmationFichier == '0' && props.data.canCustomDimensionsBatAuto && props.data.isInternalUser && props.data.customerView))) || reuploadBtnAdminBatValide;

  useEffect(() => {
    if(batAutoRotation !== 0) {
      props.changeOptionEvent('batAutoRotation', batAutoRotation, true);
    } else if(batAutoRemoveBackground) {
      props.changeOptionEvent('batAutoRemoveBackground', batAutoRemoveBackground, true);
    }
  }, [batAutoRotation, batAutoRemoveBackground]);

  function setOptionBatAuto(event: React.MouseEvent<HTMLButtonElement>, type : string){
    if(type == 'rotation') {
      setBatAutoRotation(90);
    } else if(type == 'removeBG') {
      if(confirm('Remarque : cette fonctionnalité est expérimentale. Certains éléments peuvent être supprimés de votre image. Veuillez vous assurer que le résultat obtenu correspond bien à vos attentes.')) {
        setBatAutoRemoveBackground(!batAutoRemoveBackground);
      }
    } else if(type == 'dimensions') {
      event.stopPropagation();
      setShowResize(!showResize);
    }
  }

  function handleEnableDeplieCmjn() {
    enableDeplieCmjn(!isDeplieCmjn);
  }

  const preTitle = props.data.cmjnCs?.isPersonnalise ? `Couleur personnalisee` : `Couleur du textile`;
  const titleCmjn = `${preTitle}\nC: ${props.data.cmjnCs?.cyan} M: ${props.data.cmjnCs?.magenta} J: ${props.data.cmjnCs?.jaune} N: ${props.data.cmjnCs?.noir}`;

  const isDT = getShopRefInStorage() === 'DT';
  const isTraitePourImpression = isDT ? props.data?.cmjnCs && props.data?.originalFileInfos?.outlineProcessing === "couleurTextile" && props.data?.originalFileInfos?.statutLigneMarquageId <= 2 : props.data?.cmjnCs && props.data?.originalFileInfos?.statutLigneMarquageId <= 2;
  return (
    <div className={"batAutoBtnEditorWrapper"}>
      {!props.onlyDownload && (<><button className={'batAutoBtnEditor mb-2 d-flex align-items-center'} onClick={event => setOptionBatAuto(event, 'rotation')}>
        <Icons icon="ic-rotate" size={30} color="black" />
        <div className={"my-2 pl-2"}>Rotation de 90°</div>
      </button>
      <div>
        <BtnEditorPicker
          btnLabel="Appliquer un contour"
          icon="ic-border"
          onAcceptColor={(color) => props.onApplyOutline(true, color)}
          onClosePicker={props.resetCustomOptions}
        />

        <BtnEditorPicker
          btnLabel="Modifier la couleur"
          icon="ic-colors"
          displayPicker={props.data.displayColorPicker}
          color={props.data.batAutoColor != '' ? props.data.batAutoColor : '#000000'}
          onColorChange={props.handleChangeColors}
          onAcceptColor={props.submitHandleChangeColors}
          onClosePicker={props.resetCustomOptions}
        />

      </div>
      <button className={'batAutoBtnEditor  mb-2 d-flex align-items-center'}  onClick={event => setOptionBatAuto(event, 'removeBG')}>
        <Icons icon="ic-remove-bg" size={25} color="black" />
        <div className={"my-2 pl-2"}>Suppression du fond</div>
      </button>
      {canCustomDimensions &&
        <div className={`cardResizeWrapper ${showResize ? 'is-flipped' : ''}`}>
          <button
            className={`batAutoBtnEditor  mb-2  cardResize d-flex align-items-center ${showResize ? ' d-none ' : ' '}`}
            onClick={event => setOptionBatAuto(event, 'dimensions')}>
            <Icons icon="ic-resize" size={30} color="black"/>
            <div className={"my-2 pl-2"}>Agrandir / réduire</div>
          </button>
          <div
            className={`batAutoBtnEditorWrapper cardResize  mb-2 resizeWrapper ${showResize ? ' ' : ' d-none'}`}>
            <div className={'d-flex align-items-center'}>
              <button style={{width: 'auto'}} className={`batAutoBtnEditor mr-2 mb-0`}
                      onClick={event => setOptionBatAuto(event, 'dimensions')}>
                <Icons icon="arrow_back" size={25} color="black" />
              </button>
              <div className={'flex-grow-1'}>
                <div>
                  <RenderDimensionsFields
                    canCustomDimensionsBatAuto={canCustomDimensions}
                    idCaddies={props.data.paniers[0].idCaddies}
                    order={props.data.order}
                    surface={props.data.surface}
                    emplacement={props.data.emplacement}
                    pictogramme={props.data.pictogramme}
                    creationId={props.data.fileRegisteredCreationId}
                    surfaceEmplacementId={props.data.surfaceEmplacementId}
                    getPreview={(idCaddie : string, forceUpdate: boolean) => props.getPreview(idCaddie, forceUpdate)}
                    originalFilename={props.data.fileRegisteredOriginalName}
                    identifier={'container-' + props.data.identifier}
                    dimensions={props.data.dimensionsData}
                    updateDimensions={(dimensions: Record<string, unknown>, upload: boolean = true) => {props.updateDimensions(dimensions, upload)}}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      }
        {props.data.originalFileInfos?.iteration > 0 && props.data.originalFileInfos?.canCancelAction && <RollbackAction onRollback={props.onRollback}/>}
      </>)}
      {((props.data.activateBatAuto && props.data.isInternalUser && !props.data.customerView) || props.onlyDownload) &&
        <div className={'hiddenFunctionsWrapper'}>
          <div className={"p-2"}>
            <button className={'batAutoBtnEditor d-flex align-items-center mb-2'}  onClick={(e) => {props.onDownloadFile(e, "source")}} >
              <Icons icon="file_download" size={20} color="black" className="black" /> Télécharger le fichier client
              <span title={`Identifiant du fichier client : ${props.data.originalFileInfos.original_file_id}`} className={'cursor-help text-info px-2 ml-1  bg-info white text-center '}>{props.data.originalFileInfos.original_file_id}</span>
            </button>
            {props.data.originalFileInfos?.fileIdFromOperateur && <button className={'batAutoBtnEditor d-flex align-items-center mb-2 font12'}  onClick={(e) => {props.onDownloadFile(e, "sourceOperateur")}} >
              <Icons icon="file_download" size={20} color="black" className="black" /> Télécharger le fichier modifié par l'opérateur
              <span title={`Identifiant du fichier modifié par l'opérateur : ${props.data.originalFileInfos.fileIdFromOperateur}`} className={'cursor-help text-info px-2 ml-1  bg-info white text-center '}>{props.data.originalFileInfos.fileIdFromOperateur}</span>
            </button>}
            <button className={'batAutoBtnEditor d-flex align-items-center'}  onClick={(e) => {props.onDownloadFile(e, "tiff")}} >
              <Icons icon="file_download" size={20} color="black" className="black" /> Télécharger le fichier tiff
              <span title={`Identifiant du fichier tiff : ${props.data.originalFileInfos.gfvId}`} className={'cursor-help text-info px-2 ml-1  bg-info white text-center '}>{props.data.originalFileInfos.gfvId}</span>
            </button>
            {props.data.paniers[0].withBeforeUploadStatusId > 1 && <button className={'batAutoBtnEditor d-flex align-items-center mt-2'}  onClick={(e) => {props.onDownloadFile(e, "sourceBeforeOrder")}} >
              <Icons icon="file_download" size={20} color="black" className="black" /> Télécharger le fichier source envoyé avant commande
            </button>}
            {parseInt(props.data.marquage.id, 10) === 4 && props.canDownloadEmbroidery && props.data.originalFileInfos.statutLigneMarquageId > 3 && <button className={'batAutoBtnEditor d-flex align-items-center mt-2'}  onClick={(e) => {props.onDownloadFile(e, "embroidery")}} >
              <Icons icon="file_download" size={20} color="black" className="black" /> Télécharger les fichiers de broderie
            </button>}
            <div className={'d-flex'}>
              {(props.data && props.data.originalFileInfos && props.data.originalFileInfos.outlineProcessing && props.canUpdateOutlineProcessing) &&
                  <SelectOutlineProcessing data={props.data} onChangeOutlineProcessing={props.onChangeOutlineProcessing} outlineValue={props.data.originalFileInfos.outlineProcessing} isInternalUser={props.data.isInternalUser} isInternalUserAdmin={props.data.isInternalUserAdmin} />
              }
              {isTraitePourImpression && props.canUpdateCmjn &&
                  <div className={'pl-1 my-2'}>
                    <span className={"pl-3 pr-3"} title={titleCmjn}
                          style={{border: "1px solid black", width: 20, backgroundColor: `#${props.data?.cmjnCs?.hexadecimal}`}}>&nbsp;</span>
                        <span onClick={handleEnableDeplieCmjn} className={'pl-1 cursor-pointer'}>{isDeplieCmjn ? 'Annuler' : 'Modifier'}</span>
                  </div>
              }
            </div>
            {isTraitePourImpression && props.canUpdateCmjn &&
                <UpdateCmjn isDeplie={isDeplieCmjn} data={props.data.cmjnCs} isDT={isDT} idCaddies={props.data.paniers[0].idCaddies} onUpdateCmjn={props.onUpdateCmjn}/>
            }
          </div>
        </div>
      }
    </div>
  );
}